import * as React from 'react';
import cx from 'classnames';
import { connect } from 'react-redux';
import { get } from 'lodash';
import Button from 'components/Button';
import { ERROR } from 'utils/asyncStatusHelper';
import Dropdown, { DropDownPosition } from 'components/DropDownMenu/DropDownMenu';
import { Chevron } from 'components/Icons/Icons';
import styles from './MSPincodeWidget.css';
import { LocationPin } from 'components/Icons/Icons';
import { fetchPincodeServiceability } from 'actions/pincodeActions';
import { stringTemplate } from 'components/StringWidget/StringWidget';
import { fetchRecentPincodeAction } from 'actions/pincodeActions';
import { MarketplaceId } from '@rome/request/marketplace/MarketplaceId';
import { reloadPageDataAction } from 'actions/pageActionsV4';
import shallowEqual from 'utils/shallowEqual';
import { WidgetTypeV4 } from 'rome-models/models/com/flipkart/rome/datatypes/response/page/v4/WidgetTypeV4';
import PincodeSuggesttion from './PincodeSuggestion';
import PincodeInputWidget from './PincodeInputWidget';
import Loader from 'components/Common/Loader/Loader';
import { handleLoginAction } from 'utils/LoginUtils/smartLoginHelper';
import { makeLoginRequest } from 'actions/LoginSignupActions/loginActions';
import { showModal } from 'actions/modalActions';
import { withToast } from 'components/Toast/Toast';
import { SELECT_CITY_TEXT } from 'reducers/GroceryReducers/marketPlacePincodeReducer';
import omnitureHelper from 'utils/omnitureHelper';
const DROP_MENU_MAX_WIDTH = 250;
var pincodeOmnitureStates;
(function (pincodeOmnitureStates) {
    pincodeOmnitureStates["INVALID_PINCODE"] = "invalid-pincode";
    pincodeOmnitureStates["SERVICEABLE"] = "serviceable";
    pincodeOmnitureStates["NON_SERVICEABLE"] = "non-serviceable";
})(pincodeOmnitureStates || (pincodeOmnitureStates = {}));
class MSPincodeWidget extends React.Component {
    constructor(props) {
        super(props);
        this.handlePincodeSelectionChanged = (checkedId) => {
            this.state.pincodeInputText !== checkedId && this.handlePincodeChange(checkedId);
        };
        this.handlePincodeInputChanged = (pincode) => {
            this.setState({
                pincodeInputText: pincode
            });
        };
        this.fetchServiceability = (pincode) => {
            const { marketPlacePincode } = this.props;
            const marketplace = get(marketPlacePincode, 'marketplace');
            this.props.fetchServiceability(pincode, marketplace || MarketplaceId.GROCERY).then(data => {
                const serviceable = get(data, ['serviceability']) || false;
                serviceable && this.props.reloadPageData();
                this.setState({
                    showMenuDropDown: !serviceable,
                    showLoader: false,
                    error: !serviceable,
                    loaderText: '',
                    message: data.message || data.errorMessage
                });
                omnitureHelper.trackLink(Object.assign(Object.assign({}, (serviceable ? { events: 'event15' } : {})), { eVar52: pincode, eVar93: MarketplaceId.GROCERY, prop58: serviceable ? pincodeOmnitureStates.SERVICEABLE : pincodeOmnitureStates.NON_SERVICEABLE }), 'PincodeCheck_Grocery popup');
            });
        };
        this.handlePincodeChange = (pincode, valid = true) => {
            if (!pincode) {
                return;
            }
            if (!valid) {
                omnitureHelper.trackLink({
                    eVar52: pincode,
                    eVar93: MarketplaceId.GROCERY,
                    prop58: pincodeOmnitureStates.INVALID_PINCODE
                }, 'PincodeCheck_Grocery popup');
            }
            this.setState({
                pincode,
                pincodeInputText: pincode,
                error: !valid,
                message: !valid ? stringTemplate('invalidPincode') : '',
                showLoader: valid,
                loaderText: stringTemplate('serviceabilityText')
            }, () => {
                valid && this.fetchServiceability(pincode);
            });
        };
        this.handleLocatingStarted = () => {
            this.setState({
                error: false,
                message: stringTemplate('locationDetection'),
                showLoader: true,
                loaderText: stringTemplate('locationDetection')
            });
        };
        this.renderMNSpincodeButton = () => {
            const { marketPlacePincode } = this.props;
            const { negativeButton } = marketPlacePincode;
            const nagativeButtonActionUrl = get(negativeButton, ['action', 'url']);
            const title = get(negativeButton, ['value', 'title']);
            return (<a href={nagativeButtonActionUrl} className={styles['button-link']}>
				<Button className={styles['button']}>{title}</Button>
			</a>);
        };
        this.handleLoginModal = () => {
            const { showModal, makeLoginRequest, toast } = this.props;
            const loginPayload = {
                showModal,
                toast,
                makeLoginRequest,
                omnitureData: { source: 'Pincode', page: 'pp' }
            };
            handleLoginAction(loginPayload);
        };
        this.renderPincodesuggestion = () => {
            const { pincode } = this.state;
            return (<PincodeSuggesttion {...this.props} pincodeText={pincode} onLoginClicked={this.handleLoginModal} onPincodeSelectionChanged={this.handlePincodeSelectionChanged}/>);
        };
        this.containerRef = (c) => (this.widgetContainer = c);
        this.shakeContainer = () => {
            const element = this.widgetContainer;
            element && element.classList.remove(styles['error'], styles['shake-animation']);
            setTimeout(() => {
                element && element.classList.add(styles['error'], styles['shake-animation']);
            }, 100);
        };
        this.handleMenuToggle = (show) => () => {
            const { showLoader } = this.state;
            const pincode = get(this.props, 'marketPlacePincode.pincode') || '';
            !showLoader &&
                this.setState({
                    showMenuDropDown: show,
                    pincodeInputText: pincode,
                    pincode,
                    error: false,
                    message: ''
                });
        };
        this.trackPincodeWidgetVisibility = () => {
            omnitureHelper.trackLink({
                eVar93: MarketplaceId.GROCERY
            }, 'PinCodePopupShown');
        };
        const { marketPlacePincode } = props;
        const { pincode = '', requestedPincode = '', asyncStatus, errorMessage = '' } = marketPlacePincode;
        this.state = {
            error: asyncStatus === ERROR,
            message: errorMessage,
            pincode,
            pincodeInputText: requestedPincode !== pincode ? requestedPincode : pincode,
            showMenuDropDown: false,
            showLoader: false,
            loaderText: '',
            requestedPincode: ''
        };
        props.fetchRecentPincodes();
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (shallowEqual(this.props, nextProps))
            return;
        const { marketPlacePincode } = nextProps;
        const { pincode = '', requestedPincode = '', asyncStatus, errorMessage = '' } = marketPlacePincode;
        this.state.pincode !== pincode &&
            this.setState({
                error: asyncStatus === ERROR,
                message: errorMessage,
                pincode,
                pincodeInputText: requestedPincode !== pincode ? requestedPincode : pincode
            });
    }
    getMenuDropDown() {
        const { pincodeInputText, error, message, showLoader, loaderText } = this.state;
        const pincodeInputErrorState = error && !showLoader;
        return (<div className={styles['widget-container']}>
				<div className={styles['pincode-input-container']}>
					<PincodeInputWidget pincodeText={pincodeInputText} {...this.props} error={pincodeInputErrorState} message={message} onLocatingStarted={this.handleLocatingStarted} onPincodeSubmit={this.handlePincodeChange} onPincodeInputChanged={this.handlePincodeInputChanged}/>
					<div className={styles['container']}>
						{error && !showLoader ? (<div className={styles['message']}> {message} </div>) : (<React.Fragment>
								<Loader radius={10} width={3} className={cx(styles['pincode-loader'], { [styles['hidden']]: !showLoader })}/>
								{showLoader && loaderText}
							</React.Fragment>)}
					</div>
				</div>
				{this.renderPincodesuggestion()}
			</div>);
    }
    render() {
        const { marketPlacePincode: pincodeData } = this.props;
        const { type, widgetText } = pincodeData;
        const { showMenuDropDown } = this.state;
        const titleText = widgetText || SELECT_CITY_TEXT;
        const content = <div className={styles['content-text']}>{titleText}</div>;
        // according to oldCode: viewType === 'ALERT' - show the blocking popup
        // TODO: check post first release with product for the impact
        const isMNSAlertView = type === WidgetTypeV4.MNS_PINCODE_POPUP;
        const mouseEnterHandler = (!isMNSAlertView && this.handleMenuToggle(true)) || undefined;
        const mouseLeaveHandler = (!isMNSAlertView && this.handleMenuToggle(false)) || undefined;
        const active = isMNSAlertView ? true : showMenuDropDown;
        return pincodeData ? (<React.Fragment>
				{isMNSAlertView && <div className={styles['overlay']} onClick={this.shakeContainer}/>}
				<div ref={this.containerRef} className={styles['item-container']} onMouseEnter={mouseEnterHandler} onMouseLeave={mouseLeaveHandler}>
					<LocationPin width={12} height={16} pathClassName={styles['location-path']}/>
					<Dropdown position={DropDownPosition.CENTER} fixPosition contentMaxWidth={DROP_MENU_MAX_WIDTH} content={content} active={active} className={styles['drop-menu']} tooltipClassName={styles['dropdown-container']} containerClassName={styles['dropdown-inner-container']} onShow={this.trackPincodeWidgetVisibility}>
						{this.getMenuDropDown()}
					</Dropdown>
					<Chevron width={4.7} height={8} className={cx(styles['chevron'], { [styles['active']]: this.state.showMenuDropDown })} pathClassName={styles['chevron-path']}/>
				</div>
			</React.Fragment>) : null;
    }
}
const mapStateToProps = (state) => {
    const { pincodeData } = state;
    const suggestedPincodes = ((pincodeData && pincodeData.suggestions) || []).map(item => item.pincode);
    return {
        marketPlacePincode: state.grocery.marketPlacePincodeReducer,
        suggestions: (pincodeData && pincodeData.suggestions) || [],
        localPincodes: pincodeData.localPincodes.filter(function (val) {
            return suggestedPincodes.indexOf(val) === -1;
        }) || []
    };
};
const mapDispatchProps = {
    fetchRecentPincodes: fetchRecentPincodeAction,
    fetchServiceability: fetchPincodeServiceability,
    reloadPageData: reloadPageDataAction,
    showModal,
    makeLoginRequest
};
export default connect(mapStateToProps, mapDispatchProps)(withToast(MSPincodeWidget));
